import { apiClient } from "@api/client";
import { request } from "@api/request";
import { ClinicAuthError } from "@auth/clinicAuthClient";

import type { FixtureBox } from "./roomsClient";

/** Mirrors brian room/schemas.py CameraArea and RoomCameraAreasSet/Out. */
export interface CameraArea {
  uuid: string;
  label: string;
  box: FixtureBox;
}
export interface RoomCameraAreas {
  width: number;
  height: number;
  active: boolean;
  areas: CameraArea[];
}
export interface CameraAreasChange {
  drawn_on: "still" | "baseline";
  still_reference: string | null;
  expected_baseline_at?: string;
  areas: CameraArea[];
}
export const MAX_CAMERA_AREAS = 32;
export const roomAreasClient = {
  get: (roomUuid: string): Promise<RoomCameraAreas | null> =>
    request(() =>
      apiClient.GET("/rooms/{room_uuid}/camera/areas", {
        params: { path: { room_uuid: roomUuid } },
      }),
    ).then(
      (saved) => ({
        ...saved,
        areas: saved.areas.map((a) => ({
          ...a,
          box: [a.box[0]!, a.box[1]!, a.box[2]!, a.box[3]!] as FixtureBox,
        })),
      }),
      (error: unknown) => {
        if (error instanceof ClinicAuthError && error.status === 404)
          return null;
        throw error;
      },
    ),
  set: (roomUuid: string, change: CameraAreasChange) =>
    request(() =>
      apiClient.PUT("/rooms/{room_uuid}/camera/areas", {
        params: { path: { room_uuid: roomUuid } },
        body: {
          ...change,
          areas: change.areas.map((a) => ({ ...a, box: [...a.box] })),
        },
      }),
    ),
};
